import { useTranslation } from "../i18n/LanguageContext";

export default function MarqueeSection() {
  const { t } = useTranslation();
  const items = t.marquee;
  const doubled = [...items, ...items];

  return (
    <section
      className="py-8 overflow-hidden bg-[#0A0A0B]"
      style={{ borderTop: "1px solid #2A2A2E", borderBottom: "1px solid #2A2A2E" }}
      data-testid="marquee-section"
    >
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#0A0A0B] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#0A0A0B] to-transparent z-10 pointer-events-none" />
        <div className="flex animate-marquee">
          {doubled.map((item, index) => (
            <div key={`${item}-${index}`} className="flex items-center gap-8 px-8 whitespace-nowrap">
              <span
                className="hover:text-[#C9A96E] transition-colors duration-300"
                style={{
                  fontFamily: "Cormorant Garamond, serif",
                  fontWeight: 500,
                  fontStyle: "italic",
                  fontSize: "22px",
                  letterSpacing: "-0.01em",
                  color: "#2A2A2E",
                }}
              >
                {item}
              </span>
              <span style={{ color: "rgba(201, 169, 110, 0.3)" }}>•</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
